import styled from 'styled-components'
import Typography from '../UI/Typography'
import { HStack, VStack } from '../../global/styles'

export const Headline = styled(Typography).attrs({
  variant: 'headingL',
  bold: true
})`
  margin-bottom: 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.skyNeutral_1};
`

export const ModalHeader = styled(VStack)`
  width: 400px;
  align-items: center;
  justify-content: flex-start;
`
export const ButtonWrap = styled(HStack)`
  width: 100%;
  margin-top: 24px;
  justify-content: space-between;
  & > :first-child {
    margin-right: 12px;
  }
`
export const ModalWrap = styled(VStack)`
  padding: 24px;
`
export const ErrorWrap = styled(Typography).attrs({
  variant: 'textS'
})`
  text-align: center;
  color: red;
`
